export default __webpack_public_path__ + "static/media/Group470.21d8d496.png";